import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=14e204ac&scoped=true"
import script from "./FileForm.vue?vue&type=script&lang=js"
export * from "./FileForm.vue?vue&type=script&lang=js"
import style0 from "./FileForm.vue?vue&type=style&index=0&id=14e204ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e204ac",
  null
  
)

export default component.exports